import React from 'react';
import './SuggestedQuestions.css';

/**
 * Clickable suggestion chips for welcome prompts and API follow-up questions.
 * @param {Object} props
 * @param {string[]} props.questions - Question strings to display
 * @param {string} [props.intro] - Optional intro line shown above the chips
 * @param {function} props.onSelect - Called with the question text when a chip is clicked
 * @param {boolean} [props.disabled=false] - Disable interaction while loading
 * @returns {JSX.Element|null}
 */
const SuggestedQuestions = ({ questions, intro, onSelect, disabled = false }) => {
  if (!questions?.length) {
    return null;
  }

  return (
    <div className="suggested-questions">
      {intro && <p className="suggested-questions-intro">{intro}</p>}
      {questions.map((question) => (
        <button
          key={question}
          type="button"
          className="suggested-question-chip"
          disabled={disabled}
          onClick={(e) => {
            e.stopPropagation();
            if (!disabled && onSelect) {
              onSelect(question);
            }
          }}
        >
          {question}
        </button>
      ))}
    </div>
  );
};

export default SuggestedQuestions;
